import PropTypes from 'prop-types';

import { ButtonV2, LoaderSkeleton, OverlayTriggerTooltip, PlusPlainIcon } from '@utilities';
import { getPromptPillValue, getPromptPillTooltip } from '@helpers';
import {
  getPromptPillIcon,
  transformPromptSelections,
} from '../../../../../../pages/Narratives/utilities/helpers.js';
import { PILL_KEYS } from '../../../../../../pages/Narratives/utilities/constants.js';

import styles from './_index.module.scss';

const TitleSelectedPrompts = ({ answers, handleReprompt, selectedPrompts }) => {
  let pillPrompts = selectedPrompts;
  if (answers?.subscribedChannels?.length > 0) {
    pillPrompts = [
      ...pillPrompts,
      {
        id: 'subscribedChannels',
        name: 'Subscribed Channels',
        promptKey: 'subscribedChannels',
      },
    ];
  }

  const pillCount = PILL_KEYS.filter((key) => answers?.[key]?.length > 0).length;
  const emptyPrompts = selectedPrompts.filter(
    (prompt) => !answers?.[prompt.promptKey] || answers[prompt.promptKey]?.length === 0
  );

  if (selectedPrompts.length === 0) {
    const loaderPills = [];
    for (let i = 0; i < pillCount; i++) {
      loaderPills.push(
        <LoaderSkeleton height={24} key={`loader-pill-${i}`} width={150}>
          <rect height="24px" rx="8" ry="8" width="150px" x="0" y="0" />
        </LoaderSkeleton>
      );
    }
    return <div className={styles['title-selected-prompts']}>{loaderPills}</div>;
  }

  const canReprompt = typeof handleReprompt === 'function';

  return (
    <div className={styles['title-selected-prompts']}>
      {pillPrompts?.map((prompt, index) => {
        const answer = answers?.[prompt.promptKey];
        if (!answer) return null;
        const transformedAnswer = transformPromptSelections({ answers: answer, prompt });
        const answerValues = transformedAnswer.flatMap((item) => item.values);
        const value =
          prompt.promptKey !== 'subscribedChannels'
            ? getPromptPillValue({
                answers: { [prompt.id]: answerValues },
                prompt: { ...prompt, isPrefixIncluded: false },
              })
            : 'Subscribed Channels';
        const tooltip =
          prompt.id !== 'date_range'
            ? getPromptPillTooltip({
                answers: { [prompt.id]: answerValues },
                hasTooltip: true,
                prompt,
              })
            : '';
        const icon = getPromptPillIcon({ promptKey: prompt.promptKey });
        return (
          <OverlayTriggerTooltip content={tooltip} key={`prompt-${index}`}>
            <ButtonV2
              className={styles['title-selected-prompt-pill']}
              icon={icon}
              isRequired={value === prompt.emptyValue}
              key={`prompt-${index}`}
              onClick={
                canReprompt && prompt.promptKey !== 'subscribedChannels'
                  ? () => handleReprompt(prompt)
                  : null
              }
              size="small"
              variant="subtle"
            >
              {value}
            </ButtonV2>
          </OverlayTriggerTooltip>
        );
      })}
      {emptyPrompts.length > 0 && (
        <ButtonV2
          className={styles['title-selected-prompt-pill']}
          icon={<PlusPlainIcon />}
          onClick={canReprompt ? () => handleReprompt(emptyPrompts[0]) : null}
          size="small"
          variant="subtle"
        >
          Add Prompts
        </ButtonV2>
      )}
    </div>
  );
};

TitleSelectedPrompts.propTypes = {
  answers: PropTypes.object.isRequired,
  handleReprompt: PropTypes.func,
  selectedPrompts: PropTypes.array.isRequired,
};

export default TitleSelectedPrompts;
